import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot } from '@angular/router';
import { map } from 'rxjs/operators';

import { AuthService, LoginService } from 'app/services';

export const loggedInGuard: CanActivateFn = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
    const router: Router = inject(Router);
    const authService = inject(AuthService);
    const loginService = inject(LoginService);

    return authService.isLoggedIn().pipe(
        map((loggedIn) => {
            if (loggedIn) return true;
            loginService.setRedirectState(state);
            router.navigate(['/login']);
            return false;
        }),
    );
};
